import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { ConsultantModel } from '@lib/models/consultant/consultant.model';
import { ResiliationModel } from '@lib/models/resiliation/resiliation.model';
import { ConsultantService } from '@lib/services/consultant/consultant.service';
import { OptionsService } from '@lib/services/options/options.service';
import { OuiAvatarModule } from 'omnium-ui/avatar';
import { OuiButton } from 'omnium-ui/button';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiInfosBulle } from 'omnium-ui/infos-bulle';

@Component({
  selector: 'lib-fiche-consultant-header',
  standalone: true,
  imports: [OuiAvatarModule, DatePipe, OuiButton, OuiIconModule, OuiInfosBulle],
  templateUrl: './fiche-consultant-header.component.html',
  styleUrl: './fiche-consultant-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FicheConsultantHeaderComponent {
  private readonly consultantService = inject(ConsultantService);
  private readonly optionsService = inject(OptionsService);

  readonly consultant = input.required<ConsultantModel>();
  readonly consultantResiliation = input.required<ResiliationModel | null>();
  readonly showBackButton = input.required<boolean>();
  readonly enableNavigation = input.required<boolean>();
  readonly isExpendSideNav = input<boolean>();

  readonly consultantChange = output<string>();
  readonly back = output();
  readonly close = output();
  readonly expendSideNav = output();

  readonly photoUrl = signal<string | null>(null);
  readonly managerName = computed<string>(
    () => `${this.consultant().manager?.prenom} ${this.consultant().manager?.nom}`
  );

  constructor() {
    effect(() => {
      this.getPhotoConsultant();
    });
  }

  private async getPhotoConsultant() {
    try {
      const photoUrl = await this.consultantService.getConsultantPhoto(
        this.consultant().code
      );

      this.photoUrl.set(photoUrl);
    } catch (error) {
      console.error(error);
    }
  }

  getResiliationMotifName() {
    return this.optionsService.getResiliationMotifName(
      this.consultantResiliation()?.motif
    );
  }
}
